// @file GraphQL Queries and Mutations for Folder type
import gql from 'graphql-tag'

export const CREATE_FOLDER: any = gql`
  mutation($name: String!) {
    upsertFolder(name: $name) {
      id
      name
      walls_count
      owner_id
    }
  }
`

export const UPDATE_FOLDER: any = gql`
  mutation($folderId: ID!, $name: String!) {
    upsertFolder(name: $name, id: $folderId) {
      id
      name
      walls_count
      owner_id
    }
  }
`

export const DELETE_FOLDER: any = gql`
  mutation($folderId: ID!) {
    deleteFolder(id: $folderId) {
      id
      name
      walls_count
      owner_id
    }
  }
`

export const ADD_TO_FOLDER: any = gql`
  mutation($wallId: ID!, $folderId: ID!) {
    addWallToFolder(wall_id: $wallId, folder_id: $folderId) {
      wall {
        id
        title
      }
      folder {
        id
        name
      }
    }
  }
`

export const REMOVE_FROM_FOLDER: any = gql`
  mutation($wallId: ID!, $folderId: ID!) {
    removeWallFromFolder(wall_id: $wallId, folder_id: $folderId) {
      wall {
        id
        title
      }
      folder {
        id
        name
      }
    }
  }
`

export const MOVE_TO_FOLDER: any = gql`
  mutation($fromFolderId: ID!, $toFolderId: ID!, $wallId: ID!) {
    moveWallToFolder(wall_id: $wallId, from_folder_id: $fromFolderId, to_folder_id: $toFolderId) {
      wall {
        id
        title
      }
      from_folder {
        id
        name
      }
      to_folder {
        id
        name
      }
    }
  }
`

// Gets the folders for a particular user
export const USER_FOLDERS: any = gql`
  query($userId: ID!) {
    folders(user_id: $userId) {
      id
      name
      walls_count
    }
  }
`

export const WALL_FOLDERS: any = gql`
  query($wallId: ID!) {
    wall(id: $wallId) {
      folders {
        id
        name
      }
    }
  }
`
